import { render, staticRenderFns } from "./PortalGeneral.vue?vue&type=template&id=0b60783d"
import script from "./PortalGeneral.vue?vue&type=script&lang=js"
export * from "./PortalGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports